export function describeDomElement(el) {
    let desc = el.tagName;

    if (el.id) {
        desc += '#' + el.id;
    }

    if (el.className) {
        desc += '.' + el.className.trim().split(/\s+/).join('.');
    }

    return desc;
}
